import TaskHolderModel             from 'Models/intervention/TaskHolderModel';
import SourceModel                 from 'Models/invoice/SourceModel';
import PartitionModel              from 'Models/partition/PartitionModel';
import ContractIterationItemModel  from 'Models/sales/ContractIterationItemModel';
import QuotationItemModel          from 'Models/sales/QuotationItemModel';
import doc                         from 'decorators/doc';
import model                       from 'decorators/model';
import { Timestampable }           from 'helpers/traits';
import { Blamable }                from 'helpers/traits';
import InterventionPrivateApiModel from 'modelx/models/abstracts/InterventionPrivateApiModel';

const customDoc = doc;

@model.staticLabel('TaskGroup')
@model.urnResource('task_group')
@doc.path('/task_groups/{?id}')
export default class TaskGroupModel extends Blamable(Timestampable(InterventionPrivateApiModel)) {
	public _filters: ModelFiltersExtended<{
		'createdAt[after]': string;
		'createdAt[before]': string;
		'createdAt[strictly_after]': string;
		'createdAt[strictly_before]': string;
		'partitionUrn': Urn;
		'updatedAt[after]': string | Date;
		'updatedAt[before]': string | Date;
		'updatedAt[strictly_after]': string | Date;
		'updatedAt[strictly_before]': string | Date;
	}> = {};

	public _sorts: ModelSortsExtended<{
		'id': string;
		'label': string;
		'updatedAt': string;
	}> = {};

	@doc.string declare label: string;
	@doc.modelUrn(PartitionModel) declare partition: PartitionModel;
	// @doc.modelUrn(SourceModel) declare source: SourceModel;
	@doc.model(TaskHolderModel) declare taskHolder: TaskHolderModel;

	@customDoc.modelUrn(SourceModel) declare source: ContractIterationItemModel | QuotationItemModel | SourceModel;
}